import React from "react";
import { validateStepInput } from "../utils/validation";

const OnboardingForm = ({
  currentStep,
  inputText,
  setInputText,
  onSendMessage,
  onQuickReply,
  onSubmit,
  onCancel,
  stepIndex,
  totalSteps,
  error,
  isSubmitting
}) => {
  if (!currentStep) return null;

  // Hide form for select type since options are shown in chat messages
  if (currentStep.type === "select") {
    return (
      <div className="bg-white rounded-2xl shadow-[0_4px_16px_rgba(0,0,0,0.05)] p-3 flex flex-col gap-2">
        <div className="flex justify-between items-center">
          <span className="text-[10px] text-gray-500">Step {Math.min(stepIndex + 1, totalSteps)} of {totalSteps}</span>
          <div className="flex gap-2">
            {error && <span className="text-[10px] text-red-600">{error}</span>}
            <button
              onClick={onCancel}
              disabled={isSubmitting}
              className="text-[11px] text-gray-600 hover:text-black"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-2xl shadow-[0_4px_16px_rgba(0,0,0,0.05)] p-3 flex flex-col gap-2">
      {currentStep.type === "options" ? (
        <div className="flex flex-col gap-2">
          {currentStep.options.map(opt => (
            <button
              key={opt}
              onClick={() => onQuickReply(opt)}
              disabled={isSubmitting}
              className="w-full px-3 py-1.5 text-xs rounded-xl bg-white border border-gray-200 text-gray-800 hover:bg-[#E7E5E1] hover:border-[#0074bc] transition-colors disabled:opacity-60 shadow-sm text-left"
            >
              {opt}
            </button>
          ))}
        </div>
      ) : (
        <div className="flex items-center gap-2">
          <input
            type="text"
            value={inputText}
            onChange={(e) => setInputText(e.target.value)}
            onKeyPress={(e) => { if (e.key === "Enter") { e.preventDefault(); onSendMessage(); }}}
            disabled={isSubmitting}
            aria-label="Type your answer"
            placeholder="Type your answer..."
            className="flex-grow outline-none text-sm text-gray-900 placeholder:text-gray-500 bg-transparent border-b border-gray-300 pb-1"
          />
          <button
            onClick={onSendMessage}
            disabled={isSubmitting || inputText.trim() === ""}
            className={`px-3 py-1.5 text-xs rounded-full ${
              inputText.trim() !== ""
                ? "bg-[#1474b6] text-white hover:bg-[#005a8f]"
                : "bg-gray-200 text-gray-500"
            }`}
          >
            Send
          </button>
        </div>
      )}
      <div className="flex justify-between items-center">
        <span className="text-[10px] text-gray-500">Step {Math.min(stepIndex + 1, totalSteps)} of {totalSteps}</span>
        <div className="flex gap-2">
          {error && <span className="text-[10px] text-red-600">{error}</span>}
          <button
            onClick={onCancel}
            disabled={isSubmitting}
            className="text-[11px] text-gray-600 hover:text-black"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default OnboardingForm;

